<template>

    <svg :class="['icon', iconVariant]" :width="size" :height="size"><use :href="'/static/icons/streamline/svg/'+iconVariant+'/'+icon+'.svg#icon'"/></svg>

</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

export default {
  name: 'IconSvg',
  props:{
      icon:String,
      bold:Boolean,
      light:Boolean,
      size:{
          type:String,
          default:16
          }
  },
  data () {
    return {

    }
  },
  mounted () {

  },
  computed:{
      iconVariant(){
          if(this.bold){
              return 'bold';
          } else if(this.light){
              return 'light';
          } else {
              return 'regular';
          }
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">


    //@import './../../scss/_theme.scss';
    /*@import 'main.scss';*/




</style>



// WEBPACK FOOTER //
// src/components/shared/IconSvg.vue